exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AddModal-module__modal-content___1gsy4{display:grid;gap:.5rem}.AddModal-module__modal-content___1gsy4 .AddModal-module__secondary-title___2Lz06{font-weight:700;margin:.5rem 0 0}.AddModal-module__button-wrapper___2DhsW{margin-top:.75rem;width:100%;display:flex;justify-content:flex-end}", ""]);

// exports
exports.locals = {
	"modal-content": "AddModal-module__modal-content___1gsy4",
	"secondary-title": "AddModal-module__secondary-title___2Lz06",
	"button-wrapper": "AddModal-module__button-wrapper___2DhsW"
};